import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Button,
} from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import SelectField from "src/components/ui-components/SelectField";
import SwitchField from "src/components/ui-components/SwitchField";
import { FieldArray } from "formik";
import { AddCircle, ExpandMore, Delete } from "@material-ui/icons";
import MenuFilterValueCreateEdit from "./MenuFilterValueCreateEdit";
import AlertMessage from "src/components/ui-components/AlertMessage";
import { getWebMethodsList } from "./ConnectionService";

const MenuFilterCreateEdit = ({ formRef }) => {
  const [webMethodsData, setWebMethodsData] = useState([]);
  const getWebMethods = () => {
    try {
      getWebMethodsList().then((res) => {
        setWebMethodsData(res);
      });
    } catch (err) {
      AlertMessage({ type: "error", msg: err.title });
    }
  };
  useEffect(() => {
    getWebMethods();
  }, []);
  return (
    <FieldArray name="pageFilter">
      {({ push, remove }) => (
        <>
          {formRef?.current?.values?.pageFilter?.length > 0 && (
            <>
              {formRef?.current?.values?.pageFilter?.map((filter, index) => (
                <Accordion key={index} defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ marginBottom: -4 }}
                    >
                      Menu Filter
                      <IconButton onClick={() => remove(index)}>
                        <Delete style={{ fontSize: 20 }} />
                      </IconButton>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={5}>
                      <Grid container item spacing={3}>
                        <Grid item xs={6}>
                          <InputField
                            label="Menu Filter Name"
                            name={`pageFilter.${index}.pageFilterName`}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputField
                            label="Menu Filter Type"
                            name={`pageFilter.${index}.pageFilterType`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                          <SelectField
                            name={`pageFilter.${index}.pageFilterWebMethodKey`}
                            label="Web Method"
                            data={webMethodsData}
                            dataTextField="webMethodName"
                            dataValueField="webMethodKey"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputField
                            label="Menu Filter Fields Separator"
                            name={`pageFilter.${index}.pageFilterFieldsSeparater`}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputField
                            label="Sort Order"
                            name={`pageFilter.${index}.sortOrder`}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <SwitchField
                            name={`pageFilter.${index}.hasConfigurableWidgets`}
                            label="Has Configurable widgets"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <SwitchField
                            name={`pageFilter.${index}.isEnabled`}
                            label="Is Enabled"
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <MenuFilterValueCreateEdit
                          formRef={formRef}
                          index={index}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    sx={{
                      textAlign: "right",
                      paddingRight: 2,
                      padding: 2,
                    }}
                  >
                    <Button
                      sx={{
                        background:
                          "linear-gradient(to bottom, #09735e, #09735e)",
                        minWidth: 100,
                        marginRight: 1,
                      }}
                      variant="contained"
                      type="button"
                      startIcon={<AddCircle />}
                      onClick={() => {
                        const newPageFilter = {
                          pageFilterValueName: "",
                          pageFilterValue: "",
                          isDefault: false,
                          sortOrder:
                            formRef?.current?.values?.pageFilter[index]
                              .pageFilterValues?.length + 1,
                        };
                        formRef?.current?.setFieldValue(
                          `pageFilter.${index}.pageFilterValues`,
                          [
                            ...formRef?.current?.values?.pageFilter[index]
                              .pageFilterValues,
                            newPageFilter,
                          ]
                        );
                      }}
                    >
                      Add Menu Filter Value
                    </Button>
                  </Grid>
                </Accordion>
              ))}
            </>
          )}
        </>
      )}
    </FieldArray>
  );
};

export default MenuFilterCreateEdit;
